import React, { useEffect, useRef } from "react";
import { fixtureOpen } from "../Pages/RoundToJoin/roundToJoin.slice";
import { useDispatch } from "react-redux";

const ConfirmPopup = ({ message, onConfirm, onCancel }) => {
  const popupRef = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        onCancel(); // Close the popup on outside click
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onCancel]);

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
      <div
        onClick={(e) => e.stopPropagation()} // ADD THIS LINE
        className="bg-white rounded-lg shadow-xl p-6 w-full max-w-sm text-center space-y-6"
      >
        <p className="text-lg font-semibold text-gray-800">{message}</p>
        <div className="flex justify-center gap-4">
          <button
            onClick={onCancel}
            className="px-4 py-2 bg-gray-300 text-gray-800 rounded-lg"
          >
            No
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-green-600 text-white rounded-lg"
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmPopup;
